/**
 * 手机（或任何页面）上的报错自动传回 Mac（ADR-0012）：未处理的异常、Promise 拒绝、接口失败。
 * 攒一小批再发；发送本身失败就算了，绝不因为上报而再报错。
 */
import { clientLogs } from "@/shared/api/gen/sdk.gen";

type Entry = { level: string; message: string; stack: string; url: string; at: string };

const queue: Entry[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;
const recent: Entry[] = []; // 最近的报错：一键反馈时一起带上

export function viewport(): string {
  return `${window.innerWidth}x${window.innerHeight}@${window.devicePixelRatio}`;
}

export function recentErrors(): Entry[] {
  return [...recent];
}

export function report(level: string, message: string, stack = ""): void {
  const entry = {
    level,
    message: message.slice(0, 2000),
    stack: stack.slice(0, 4000),
    url: location.pathname,
    at: new Date().toISOString(),
  };
  recent.push(entry);
  if (recent.length > 20) recent.shift();
  queue.push(entry);
  if (queue.length >= 20) void flush();
  else if (!timer) timer = setTimeout(() => void flush(), 5000);
}

async function flush(): Promise<void> {
  if (timer) clearTimeout(timer);
  timer = null;
  const entries = queue.splice(0, 50);
  if (!entries.length) return;
  try {
    await clientLogs({
      body: { entries, viewport: viewport(), user_agent: navigator.userAgent.slice(0, 200) },
    });
  } catch {
    /* 上报失败不再上报 */
  }
}

export function installTelemetry(): void {
  window.addEventListener("error", (e) =>
    report("error", e.message || String(e.error), e.error?.stack ?? ""),
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason as { message?: string; stack?: string } | undefined;
    report("error", reason?.message ?? String(e.reason), reason?.stack ?? "");
  });
  window.addEventListener("pagehide", () => void flush());
}
